exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".navbar-wrapper{ width:100%;}\r\n.img-fluid {\r\n    height: 30px;\r\n}\r\n.logoText {\r\n    padding-left: 7px;\r\n    display: inline-block;\r\n    vertical-align: middle;\r\n\ttext-transform: none;\r\n}\r\n\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /workspace/backend-server/src/app/layout/header/header.component.css
// module id = ../../../../../src/app/layout/header/header.component.css
// module chunks = main